import { __decorate } from "tslib";
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import Loader from "../../../components/widgets/loader.vue";
import simplebar from "simplebar-vue";
import { VendorModel } from "@/store/models/vendor/vendorDTO";
import { VendorModule } from "@/store/modules/vendor.module";
import vendorMachine from "./machines/vendorMachine";
import { interpret } from "xstate/lib/interpreter";
import Swal from "sweetalert2";
import VendorUpsertComponent from "./components/VendorUpsertComponent.vue";
import DeleteComponent from "@/components/deleteComponent.vue";
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let VendorsListing = /** @class */ (() => {
    let VendorsListing = class VendorsListing extends Mixins(BaseMixer) {
        constructor() {
            // DATA
            super(...arguments);
            this.searchKey = "";
            this.machine = vendorMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.newVendor = null;
            this.vendorUnderEdit = null;
            this.title = "Vendors";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Assets",
                    href: "#",
                },
                {
                    text: "Vendors",
                    active: true,
                },
            ];
        }
        openDeleteModal(vendorId, isTrue) {
            this.vendorIdToDelete = vendorId;
            if (isTrue == true) {
                Swal.fire({
                    text: "Sorry! This Vendor is currently used in assets and therefore cannot be deleted.",
                    icon: "warning",
                    confirmButtonColor: "#34c38f",
                    confirmButtonText: "Okay",
                }).then(() => { });
            }
            else {
                this.machineService.send({ type: "DELETE_VENDOR" });
            }
        }
        deleteVendor() {
            this.machineService.send({ type: "DELETING_VENDOR", vendorId: this.vendorIdToDelete });
        }
        //Methods
        send(event) {
            this.machineService.send(event);
        }
        get filteredVendors() {
            if (this.searchKey != "") {
                return VendorModule.venders.filter((x) => x.vendorName.toLowerCase().indexOf(this.searchKey.toLowerCase()) > -1 || x.vendorName.toLowerCase().indexOf(this.searchKey.toLowerCase()) > -1);
            }
            return VendorModule.venders;
        }
        get sortedFilteredVendors() {
            return this.filteredVendors;
        }
        //Computed
        addNewVendor() {
            this.newVendor = new VendorModel();
            this.searchKey = "";
            this.send({ type: "ADDING_VENDOR" });
        }
        saveVendor() {
            this.send({ type: "SAVE_VENDOR", newVendor: this.newVendor });
        }
        editVendor(vendor) {
            this.searchKey = "";
            this.vendorUnderEdit = Object.assign({}, vendor);
            this.send({ type: "EDIT_VENDOR" });
        }
        amIaVendorUnderEdit(vendor) {
            if (this.vendorUnderEdit != null) {
                return this.vendorUnderEdit.id == vendor.id;
            }
            return false;
        }
        updateVendor() {
            this.send({ type: "UPDATE_VENDOR", updateVendor: this.vendorUnderEdit });
        }
        //Lifecycle
        created() {
            this.machineService.start();
            this.machineService.onTransition((state) => {
                var previousState = this.state;
                this.state = state;
            });
        }
    };
    VendorsListing = __decorate([
        Component({
            name: "VendorsListing",
            components: {
                Layout,
                PageHeader,
                Loader,
                simplebar,
                VendorUpsertComponent,
                DeleteComponent,
            },
        })
    ], VendorsListing);
    return VendorsListing;
})();
export default VendorsListing;
